export default __webpack_public_path__ + "static/media/2t.431eff81.jpg";